/*
 *   File : goal-summary.js
 *   Author : https://evoqins.com
 *   Description : Goal summary page
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Modal } from "bootstrap";
import { toast } from "react-toastify";

//custom components
import { PrimaryButton, TextButton } from "../../Component/Buttons";
import { DataTableComponent } from "../../Component/DataTable";
import { APIService } from "../../Service";
import { _goalSummary, _setGoal } from "../../Helper";
import { BreadCrumbs } from "../../Component/Other";
import { ChangeFundAllocationModal, GoalInvestModal, PaymentStatusModal, UpdateNomineeInfoModal } from "../../Component/Modal";
import GaugeComponent from "react-gauge-component";
import { Icon } from "../../Component/Icon";

// COLORS
import Colors from "../../Style/color.scss"

//assets
import Loader from "../../Assets/Images/coloured_loader.svg";


const BREADCRUMBS = [
    {
        label: "Home",
        path: "/"
    },
    {
        label: "Life goals",
        path: "/goals"
    },
];



const GoalSummary = (props) => {

    const location = useLocation();
    const { state } = location;
    const navigate = useNavigate();

    const { USER_DATA: userData } = useSelector(store => store.Reducer);

    const [sip, setSip] = useState(0);
    const [lumpsum, setLumpsum] = useState('0');
    const [tenure, setTenure] = useState(0);
    const [goalDetail, setGoalDetail] = useState({});

    const [goalSummary, setGoalSummary] = useState({});
    const [loading, setLoading] = useState(true);
    const [breadcrumbs, setBreadCrumbs] = useState([]);

    const [showInvestModal, setShowInvestModal] = useState(false);
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [paymentModalType, setPaymentModalType] = useState("");

    const [investLoading, setInvestLoading] = useState(false);

    const [showNomineeInfoModal, setShowNomineeInfoModal] = useState(false);
    const [showChangeFundModal, setShowChangeFundModal] = useState(false);
    const [isFundsUpdating, setIsFundsUpdating] = useState(false);
    const [isFundsUpdated, setIsFundsUpdated] = useState(false);

    // data table column 
    const TABLE_COLUMNS = [
        {
            name: 'Fund Name',
            selector: row => row.scheme_name,
            width: "400px",
            wrap: true,
            center: false,
            style: {
                cursor: "pointer",
                textAlign: "left",
            }
        },
        {
            name: 'Allocation',
            selector: row => row.allocation_percentage_text,
        },
        {
            name: 'SIP Amount',
            cell: row => <div className="e-cell-sip">
                {row.sip_amount_text}
            </div>
        },
        {
            name: 'Lumpsum amount',
            width: "180px",
            cell: row => <div className="e-cell-lumpsum">
                {row.lumpsum_amount_text}
            </div>
        },
    ];

    useEffect(() => {
        if (props.savedGoalId) {
            sessionStorage.setItem(`saved_goal_id`, props.savedGoalId);
        }
    }, [props.savedGoalId]);

    useEffect(() => {
        window.addEventListener('hashchange', () => {
            setShowInvestModal(false);
            setShowPaymentModal(false);
            navigate("/goals");
        });
    }, []);

    useEffect(() => {
        window.scrollTo({
            top: 0, behavior: 'smooth' //scroll top
        });

        _getGoalDetail();

    }, []);

    useEffect(() => {
        if (goalDetail["name"]) {
            setSip(goalDetail.calculated_sip);
            setLumpsum(goalDetail.lumpsum);
            setTenure(goalDetail.tenure);
            setBreadCrumbs([...BREADCRUMBS, { label: props.customGoalName || goalDetail.name }]);
        }
    }, [goalDetail, props.customGoalName]);

    useEffect(() => {
        if (showInvestModal == true) {
            let invest_modal = new Modal(document.querySelector("#invest-goal-modal"));
            invest_modal.show();
        };
    }, [showInvestModal]);

    useEffect(() => {
        if (showPaymentModal == true) {
            let payment_modal = new Modal(document.querySelector("#payment-status-modal"));
            payment_modal.show()
        }
    }, [showPaymentModal]);

    useEffect(() => {
        if (showNomineeInfoModal) {
            new Modal(document.querySelector("#update-nominee")).show();
        }
    }, [showNomineeInfoModal]);

    useEffect(() => {
        if (showChangeFundModal) {
            new Modal(document.getElementById("change-fund-allocation-modal")).show();
        }
    }, [showChangeFundModal]);


    const _handleCloseInvestModal = (type) => {

        // Closing modal
        var button = document.getElementById("goal-invest-modal-close");
        button.click();

        setShowInvestModal(false);

        if (type) {
            setShowPaymentModal(true);
            setPaymentModalType(type);
        };

    };

    const _handleFundClick = (data) => {

        navigate("/explore/fund-details", {
            state: {
                fund_id: data.mf_id,
            }
        })
    };

    const _handleOpenChangeFundModal = () => {
        setShowChangeFundModal(true);
    };

    const _handleCloseChangeFundModal = () => {
        setShowChangeFundModal(false);
        setIsFundsUpdated(false);
    };

    const _handleUpdateFunds = (funds) => {
        _updateGoalAllocation(funds);
    };

    //handle back
    const _handleBack = () => {

        // this is the current url : goals/retirement#configure
        // we need to remove the #configure from the url
        // and navigate to the goals page
        const url = window.location.href;
        const urlWithoutHash = url.split('#')[0];
        navigate(urlWithoutHash, {
            state: {
                goal_id: location.state?.goal_id,
                is_summary: false,
            }
        });
    };

    //handle invest modal
    const _handleInvestNow = () => {
        setInvestLoading(true);
        _handleInvestSet();
    };

    //API- Get home data 
    const _getGoalDetail = (use_custom = false) => {

        let api_version = 3;
        let is_post = true;
        let url = 'goal/detail';
        let data = {
            "goal_id": state.goal_id,
            "use_custom": use_custom
        };

        APIService(is_post, url, data, null, api_version).then((response) => {
            if (response.status_code === 200) {
                setGoalDetail(response.data);
            } else {
                setGoalDetail({});
                navigate("/goals");
            }
            setLoading(false);
        });
    };

    // API - Update goal allocation
    const _updateGoalAllocation = (funds) => {
        let api_version = 3;
        let is_post = true;
        let url = "goal/allocation";
        let data = {
            "goal_id": props.savedGoalId || sessionStorage.getItem(`saved_goal_id`),
            "funds": funds.map((fund) => ({
                "mf_id": fund.mf_id,
                "allocation": Number(fund.allocation),
            })),
        };

        setIsFundsUpdating(true);

        APIService(is_post, url, data, null, api_version).then((response) => {
            if (response.status_code === 200) {
                // The modal stays open and shows the success view
                setIsFundsUpdated(true);
                _getGoalDetail(true);
            } else {
                toast.dismiss();
                toast.error(response?.message ?? "Something went wrong", {
                    className: "e-toast",
                });
            }
            setIsFundsUpdating(false);
        });
    };

    //handle calculate 
    const _handleInvestSet = () => {

        if (userData?.show_add_nominee_banner) {
            setShowNomineeInfoModal(true);
            setInvestLoading(false);
            return;
        }

        if (goalDetail.risk_score === null) {

            toast.dismiss();

            toast.error("Please complete your risk profile to invest", {
                className: "e-toast",
            });

            setInvestLoading(false);
            return;
        };

        _getGoalSummary();

    };

    //API - get goal summary 
    const _getGoalSummary = () => {

        let param = {
            "goal_id": state.goal_id,
            "type": null,
        };

        _goalSummary(param).then(response => {
            if (response.status_code === 200) {
                setShowInvestModal(true);
                setGoalSummary(response.data);
            } else {
                setGoalSummary({});
                toast.dismiss();
                toast.error(response.message, {
                    className: "e-toast",
                });
            }

            setInvestLoading(false);
        })
    };

    return (
        <>
            <div className="row min-h-100vh pb-4 pb-sm-5 e-bg-lotion px-4 px-sm-5 ps-lg-4 pe-lg-0 padding-26px-top e-border-radius-TL-BL-24px pb-5">
                {
                    loading ?
                        <div className="min-h-100vh text-center mt-5" >
                            <img src={Loader}
                                draggable={false}
                                alt="loader" />
                        </div>
                        :
                        <div className="col-lg-11 p-0 pb-4 pb-sm-5">
                            {/* breadcrumbs */}
                            <BreadCrumbs data={breadcrumbs} />

                            {/* page title */}
                            <header className="d-flex align-items-center gap-3 mt-4 mb-4">
                                <button type="button"
                                    className="d-flex p-0 no-border no-outline e-bg-transparent cursor-pointer"
                                    aria-label="Back to life goals"
                                    onClick={_handleBack}>
                                    <Icon icon="arrow-back-left" size={24} />
                                </button>
                                <h1 className="mb-0 e-text-chinese-black e-alt-font-poppins e-font-weight-400 e-font-16 line-height-24px">
                                    Investment details
                                </h1>
                            </header>
                            {/* gauge chart */}
                            <div className="px-0">
                                <div className="row pt-4">
                                    <div className="col-md-5 mb-4">
                                        {
                                            (goalDetail.risk_score?.score > 0) === false &&
                                            <h4 className="e-font-16-res mb-4 e-text-charleston-green e-font-18 e-alt-font-poppins e-font-weight-600 line-height-24px">
                                                Risk profile
                                            </h4>
                                        }
                                        {
                                            goalDetail.risk_score?.score > 0 ?

                                                <div className='e-border-radius-16 e-bg-cultured p-4 text-center'>
                                                    <h4 className="mb-0 text-start e-text-eerie-black e-primary-font-inter e-font-weight-500 e-font-16 line-height-20px">
                                                        Your risk score
                                                    </h4>
                                                    <div className="position-relative">
                                                        <GaugeComponent type="semicircle"
                                                            arc={{
                                                                cornerRadius: 16,
                                                                colorArray: [Colors.iguana_green, Colors.orange_yellow, Colors.fuzzy_wuzzy_red],
                                                                padding: 0.02,
                                                                width: 0.17,
                                                                subArcs:
                                                                    [
                                                                        { limit: 50 },
                                                                        { limit: 70 },
                                                                        { limit: 80 },
                                                                    ]
                                                            }}
                                                            pointer={{ type: "blob", animationDelay: 0 }}
                                                            value={goalDetail.risk_score.score * 10} />
                                                        <p className="mb-0 margin-top-neg-56px  e-text-charleston-green e-font-52 e-alt-font-poppins e-font-weight-600 line-height-24px">
                                                            {goalDetail.risk_score.score}
                                                        </p>
                                                        <p className="mb-0 pt-4 mt-1 e-text-charleston-green e-font-16 e-alt-font-poppins e-font-weight-600 line-height-30px">
                                                            {goalDetail.risk_score.score_text}
                                                        </p>
                                                    </div>
                                                </div>
                                                :
                                                <div>
                                                    {/* <h4 className="e-font-16-res mb-4 e-text-charleston-green e-font-18 e-alt-font-poppins e-font-weight-600 line-height-24px">
                                                    Risk profile
                                                </h4> */}
                                                    {/* check risk card */}
                                                    <div className="e-bg-magnolia-dark p-xl-4 p-lg-4 p-md-4 p-sm-3 p-3 e-border-radius-16">
                                                        <h6 className="e-font-16-res e-text-charleston-green e-font-18 e-alt-font-poppins e-font-weight-600 line-height-24px">
                                                            What's your risk profile
                                                        </h6>
                                                        <p className="e-font-14-res mb-0 e-text-onyx e-font-16 e-alt-font-poppins e-font-weight-400 line-height-22px">
                                                            Import and export your external portfolio in just 5 minutes.
                                                        </p>
                                                        <div className="pt-3 pt-sm-4 mt-sm-2">
                                                            <PrimaryButton name="Check now"
                                                                className="px-3 py-2 e-primary-button-hover transition"
                                                                onPress={() => navigate("/risk-profiler")} />
                                                        </div>
                                                    </div>
                                                </div>
                                        }
                                    </div>


                                    <div className="col-xl-7 col-lg-7 col-md-7">
                                        <h4 className="e-font-16-res mb-4 e-text-charleston-green e-font-18 e-alt-font-poppins e-font-weight-600 line-height-24px">
                                            Allocation based on your risk score
                                        </h4>

                                        {/* risk score */}
                                        <div className="e-border-radius-16 e-bg-cultured p-xl-4 p-lg-4 p-md-4 p-sm-3 p-3 ">
                                            <div className="d-flex justify-content-space-between padding-12px-bottom">
                                                <p className="mb-0 e-text-slate-gray e-font-14 e-alt-font-poppins e-font-weight-400 line-height-14px">
                                                    0
                                                </p>
                                                <p className="mb-0 e-text-slate-gray e-font-14 e-alt-font-poppins e-font-weight-400 line-height-14px">
                                                    100%
                                                </p>
                                            </div>

                                            {/* Allocation graph */}
                                            <div className="height-40px-res progress-stacked e-border-radius-12 h-48 mt-2 mb-4">
                                                {
                                                    (goalDetail.cap_allocation || []).map((item, index) => (
                                                        <div style={{ width: `${item.percentage}%` }}
                                                            className="progress h-100"
                                                            role="progressbar"
                                                            key={index} >
                                                            <div style={{ backgroundColor: item.color }}
                                                                className="progress-bar"></div>
                                                        </div>
                                                    ))
                                                }
                                            </div>

                                            <div className="">
                                                <div className="d-flex justify-content-space-between">
                                                    <div className="col-9">
                                                        <h6 className="pb-3 e-font-14-res mb-0 e-text-charleston-green e-font-16 e-alt-font-poppins e-font-weight-600 line-height-24px letter-spacing-neg-2">
                                                            Name
                                                        </h6>
                                                    </div>
                                                    <div className="col-3 text-center">
                                                        <h6 className="e-font-14-res mb-0 mb-3 e-text-charleston-green e-font-16 e-alt-font-poppins e-font-weight-600 line-height-24px letter-spacing-neg-2">
                                                            Allocation
                                                        </h6>
                                                    </div>
                                                </div>
                                            </div>

                                            {
                                                (goalDetail.cap_allocation || []).map((data, key) => (
                                                    <div className="pt-2" key={key}>
                                                        <div className="d-flex align-items-center">
                                                            <div className="col-9 d-flex align-items-center gap-2 pb-0">
                                                                <Icon icon="bullet"
                                                                    color={data.color}
                                                                    size={"1rem"} />
                                                                <p className="e-font-14-res mb-0 ps-sm-2  e-text-charleston-green e-font-16 e-alt-font-poppins e-font-weight-400 line-height-24px letter-spacing-neg-2">
                                                                    {data.label}
                                                                </p>
                                                            </div>
                                                            <div className="col-3 text-center">
                                                                <p className="e-font-14-res mb-0 e-text-charleston-green e-font-16 e-alt-font-poppins e-font-weight-400 line-height-24px letter-spacing-neg-2">
                                                                    {data.allocation_percentage_text}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))

                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* data table */}
                            <div className="px-0 pt-4 mt-1">
                                <div className="e-border-radius-16 e-bg-cultured px-3 py-2 text-center e-goal-table">
                                    <DataTableComponent
                                        columns={TABLE_COLUMNS}
                                        // data={goalDetail.suggestion.data[0].data}
                                        data={goalDetail.funds}
                                        rowClick={_handleFundClick} />
                                    <div className="d-flex justify-content-center py-3">
                                        <TextButton name="Edit Fund & allocation"
                                            type={2}
                                            fontSize="e-font-14"
                                            onClick={_handleOpenChangeFundModal} />
                                    </div>
                                </div>
                            </div>
                            <div className="text-center padding-40px-top mx-auto col-xl-4 col-lg-4 col-md-4 col-sm-6 col-8">
                                <PrimaryButton name="Continue"
                                    loading={investLoading}
                                    disabled={investLoading}
                                    className="w-100 padding-12px-top padding-12px-bottom"
                                    onPress={_handleInvestNow} />
                            </div>
                        </div>
                }
            </div>

            {/* goal invest modal */}
            {
                showInvestModal &&
                <GoalInvestModal
                    goalId={state.goal_id}
                    reinvest={false}
                    summary={goalSummary}
                    onCloseModal={_handleCloseInvestModal} />
            }

            {/* Payment status modal */}
            {
                showPaymentModal &&
                <PaymentStatusModal type={paymentModalType}
                    investmentType="Goal"
                    onClose={(() => setShowPaymentModal(false))} />
            }


            {
                showChangeFundModal &&
                <ChangeFundAllocationModal
                    funds={goalDetail.funds}
                    loading={isFundsUpdating}
                    isUpdated={isFundsUpdated}
                    onUpdate={_handleUpdateFunds}
                    onClose={_handleCloseChangeFundModal} />
            }

            {/* Update nominee info modal */}
            {
                showNomineeInfoModal &&
                <UpdateNomineeInfoModal onClose={() => setShowNomineeInfoModal(false)} />
            }

        </>
    )
}
export default GoalSummary;